import { useEffect, useState } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { getPagesFeatureState } from '../../../services/pages-feature/index.tsx';
import { setFeatureState } from './actions/index.tsx';
import { type State, type FeatureState, pagesFeatureStates } from './types.tsx';

const actions = {
	setFeatureState,
} as const;

type Actions = typeof actions;

const initialState: State = {
	state: pagesFeatureStates.LOADING,
};

// @Export for testing
export const Store = createStore<State, Actions>({
	name: 'pagesFeatureStateStore',
	initialState,
	actions,
});

const usePagesFeatureHook = createHook(Store);

export const usePagesFeatureState = (projectId: string | number): FeatureState => {
	const [featureState, featureActions] = usePagesFeatureHook();
	const [error, setError] = useState<Error | undefined>(undefined);
	if (error) {
		setError(undefined);
		throw error;
	}
	useEffect(() => {
		const fetchData = async () => {
			try {
				const { value: isEnabled } = await getPagesFeatureState(projectId);
				featureActions.setFeatureState(isEnabled);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (thrownError: any) {
				setError(thrownError);
			}
		};
		fetchData();
	}, [featureActions, projectId]);

	return featureState.state;
};
